import { useTailwindBreakpoint } from '@headless-workspace/core-ui';

export const useDeviceType = (): string => {
    'use memo';

    const breakpoints = [
        { type: 'desktop', isActive: useTailwindBreakpoint('desktop') },
        { type: 'desktopS', isActive: useTailwindBreakpoint('desktopS') },
        { type: 'tablet', isActive: useTailwindBreakpoint('tablet') },
    ];
    const activeBreakpoint = breakpoints.find(({ isActive }) => isActive);

    return activeBreakpoint ? activeBreakpoint.type : 'mobile';
};
